import {isPhone} from "./utils";

export const nonZeroValidator = (value) => !parseFloat(value) ? 'Please enter valid value.': null;

export const phoneValidator = (value) => !isPhone(value) ? 'Please enter valid Phone' :null;

